import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export function ehFaturavel(v) {
  if (v === false || v === 0 || v === '0') return false;
  if (v === true || v === 1 || v === '1') return true;
  return Number(v) === 1;
}

export async function importarTempoCronometro(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/worklog/importar-tempo', body, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function fetchApontamentos(satNum) {
  const base = getBase();
  if (!base || !satNum) return { apontamentos: [], total_minutos: 0, lancado_auto: {} };
  try {
    const res = await axios.get(base + '/worklog/chamado/' + satNum, { headers: getAuthHeaders(), timeout: 15000 });
    return res?.data ?? { apontamentos: [], total_minutos: 0, lancado_auto: {} };
  } catch (err) {
    if (err?.response?.status === 501) return { apontamentos: [], total_minutos: 0, lancado_auto: {}, indisponivel: true };
    return { apontamentos: [], total_minutos: 0, lancado_auto: {} };
  }
}

export async function addApontamento(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/worklog', body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function updateApontamento(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/worklog/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function deleteApontamento(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/worklog/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function fetchTimesheet({ usuario_id, de, ate }) {
  const base = getBase();
  if (!base) return { entradas: [], total_minutos: 0 };
  try {
    const res = await axios.get(base + '/worklog/timesheet', { headers: getAuthHeaders(), params: { usuario_id, de, ate }, timeout: 15000 });
    return res?.data ?? { entradas: [], total_minutos: 0 };
  } catch (err) {
    return { entradas: [], total_minutos: 0 };
  }
}

export async function fetchFaturamento({ de, ate, cliente, usuario_id }) {
  const base = getBase();
  if (!base) return { linhas: [], totais: { minutos: 0, minutos_faturaveis: 0, valor: 0 } };
  try {
    const res = await axios.get(base + '/worklog/faturamento', { headers: getAuthHeaders(), params: { de, ate, cliente, usuario_id }, timeout: 20000 });
    return res?.data ?? { linhas: [], totais: { minutos: 0, minutos_faturaveis: 0, valor: 0 } };
  } catch (err) {
    return { linhas: [], totais: { minutos: 0, minutos_faturaveis: 0, valor: 0 } };
  }
}

export async function reprocessarValor(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const res = await axios.post(base + '/worklog/reprocessar-valor', body, { headers: getAuthHeaders(), timeout: 30000 });
  return res?.data ?? null;
}

export async function fetchTarifas() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/worklog/tarifas', { headers: getAuthHeaders(), timeout: 15000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    return [];
  }
}
export async function createTarifa(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/worklog/tarifas', body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function updateTarifa(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/worklog/tarifas/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
}
export async function deleteTarifa(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/worklog/tarifas/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}

// Helpers compartilhados
export function minutosParaTexto(min) {
  const n = Number(min) || 0;
  const h = Math.floor(n / 60);
  const m = n % 60;
  if (h && m) return `${h}h${String(m).padStart(2, '0')}`;
  if (h) return `${h}h`;
  return `${m}min`;
}
